import { useEffect, useState } from "react";
import { MapProtectedRainforestArea } from "types/map";

type Props = {
  areas: Array<MapProtectedRainforestArea>;
  map: google.maps.Map | null;
};

const MapGeoProtectedCorridors = ({ map, areas }: Props) => {
  const [dataLayer, setDataLayer] = useState<google.maps.Data | null>(null);

  useEffect(() => {
    if (!map) return;

    // Create a dedicated data layer for corridors
    const layer = new google.maps.Data({ map });
    setDataLayer(layer);

    return () => {
      layer.setMap(null); // Clean up on unmount
    };
  }, [map]);

  useEffect(() => {
    if (!dataLayer || !areas.length) return;

    // Clear existing data in this layer
    dataLayer.forEach((feature) => {
      dataLayer.remove(feature);
    });

    // Add new GEOJSON data
    areas.forEach((area) => {
      try {
        const features = dataLayer.addGeoJson(area.geoJSON);
        features.forEach((feature) => {
          feature.setProperty("strokeColor", area.areaStrokeColor);
          feature.setProperty("fillColor", area.areaFillColor);
        });
      } catch (e) {
        console.error(
          "[Map] MapGeoProtectedCorridors Failed to add GeoJSON to map",
          e
        );
      }
    });

    // Style the features
    dataLayer.setStyle((feature) => {
      return {
        fillColor: feature.getProperty("fillColor") as string,
        strokeColor: feature.getProperty("strokeColor") as string,
        strokeWeight: 1,
        fillOpacity: 0.2,
        zIndex: -1, // Ensure corridors are behind the main areas
        clickable: false, // Corridors might not need to be clickable
      };
    });
  }, [dataLayer, areas]);

  return <></>;
};

export default MapGeoProtectedCorridors;
